import React from 'react'
import Header from "../Molecules/Header"
import Footer from "../Molecules/Footer"

const PrivacyPolicy = () => {
    return (
        <div>

            <Header />
            <div className="privacy">
                <div className="page-title">
                    <h3>Privacy Policy</h3>
                </div>
                <p>At TerraMinds Research, we prioritize the privacy and security of our clients and users. Our privacy policy outlines how we collect, use, and protect your personal data when you visit our website or engage with our services. We are committed to transparency and compliance with all applicable data protection laws.
                </p>
                <h3>Information Collection</h3>
                <p>We collect personal data, including names, emails, and other necessary details, when you engage with our services or subscribe to our communications. We also gather non-personal data such as website usage statistics and cookies to enhance user experience.
                </p>
                <h3>Data Usage</h3>
                <p>The information we collect is used to improve our services, communicate with clients, and provide personalized recommendations. We do not sell or share your personal data with third parties unless required by law.
                </p>
                <h3>Data Protection</h3>
                <p>We implement industry-standard security measures to safeguard your personal information and prevent unauthorized access, disclosure, or misuse.
                </p>
                <h3>Cookies
                </h3>
                <p>We use cookies to improve your experience on our website. Cookies help us analyze website traffic and enhance functionality. You can manage your cookie preferences through your browser settings.
                </p>
                <p>For more details on how we handle your data, please read our Privacy Policy and Cookie Policy.
                </p>
                <p>If you have any questions or concerns regarding your data, please contact us at [Contact@terramindresearch.com]
                </p>
            </div>
            <Footer />
        </div>
    )
}

export default PrivacyPolicy